import FormattedMessage from 'I18n/components/FormattedMessage';
import { Tabs, Tab } from 'foundations-components/transitional/components/Tabs';
import EmbedCodeContainer from 'asset-actions-lib-forms/share/components/EmbedCodeContainer';
import { RegularFormTypes } from 'asset-actions-lib-forms/constants/form';
import ShareLink from 'asset-actions-lib-forms/share/components/ShareLink';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function ShareTabbedView({
  embedType,
  embedVersion,
  formGuid,
  formName,
  onClickPreviewShareLink,
  onClose,
  onCopyEmbedCode,
  onCopyShareLink,
  initialTab
}) {
  const defaultSelected = initialTab === 'shareLinkTab' ? 'shareLinkTab' : embedType === RegularFormTypes.SHAREABLE ? 'embedCodeTab' : 'shareLinkTab';
  return /*#__PURE__*/_jsxs(Tabs, {
    "data-test-id": "share-tabbed-view",
    defaultSelected: defaultSelected,
    children: [/*#__PURE__*/_jsx(Tab, {
      tabId: "shareLinkTab",
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "assetActionsLibForms.modals.shareDialog.shareLink.title"
      }),
      children: /*#__PURE__*/_jsx(ShareLink, {
        embedVersion: embedVersion,
        formGuid: formGuid,
        onCopyShareLink: onCopyShareLink,
        onClickPreviewLink: onClickPreviewShareLink
      })
    }), /*#__PURE__*/_jsx(Tab, {
      tabId: "embedCodeTab",
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "assetActionsLibForms.modals.shareDialog.embedCode.title"
      }),
      children: /*#__PURE__*/_jsx(EmbedCodeContainer, {
        embedVersion: embedVersion,
        formGuid: formGuid,
        formName: formName,
        onClose: onClose,
        onCopy: onCopyEmbedCode
      })
    })]
  });
}